export default __webpack_public_path__ + "static/B0302-e60d1f2c70242198d72736040473ac3e.png";